import { defaultHttpClient } from '../../httpClient';
import type { GetRelatedGoodsResponse } from './types';

export const getRelatedGoods = (goodsSno: number) => {
  return defaultHttpClient
    .request<GetRelatedGoodsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/related_goods/`,
    })
    .then(result => result.data);
};
